// extracted by mini-css-extract-plugin
export default {"flavor_option":"b2","out_of_stock_text":"c2","out_of_stock":"e2","flavor_option_image":"f2","flavor_option_info":"g2","flavor_option_title":"h2","flavor_option_limited":"i2","flavor_option_amount_wrapper":"j2","flavor_option_amount_button":"k2","zero_amount":"l2","no_flavors":"m2","no_flavors_active":"n2","flavor_option_select_wrapper":"o2","flavor_option_select_wrapper__selected":"p2"};
    if(module.hot) {
      // 1743628930076
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  